import Http from "@/core/services/api.service";
import { service_url } from "../../../config";

export function getStats(filter) {
  return Http._axios({
    url: `${service_url}/api/v1/dashboard/stat/?${filter ? filter : ""}`,
    method: `get`,
  });
}
